import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { api } from "@/lib/api";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";

function Icon({ name, className }) {
  const I = Icons[name] || Icons.Shield;
  return <I className={className} />;
}

export default function ServicesPage() {
  const { openForm } = useOutletContext();
  const [products, setProducts] = useState([]);
  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
      <div className="max-w-3xl">
        <span className="text-xs uppercase tracking-[0.25em] asg-primary font-semibold">Hizmetler</span>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold mt-3 tracking-tight" data-testid="services-title">
          Sigorta ürün <span className="asg-primary">portföyümüz</span>
        </h1>
        <p className="mt-6 text-lg text-zinc-300 leading-relaxed">
          Aşağıdaki tüm ürünler için ücretsiz teklif alabilir, size özel paket oluşturabiliriz.
        </p>
      </div>

      <div className="mt-14 grid gap-6">
        {products.map((p, idx) => (
          <div
            key={p.key}
            className="asg-card rounded-2xl grid md:grid-cols-12 gap-6 p-6 md:p-8"
            data-testid={`service-row-${p.key}`}
          >
            <div className="md:col-span-3 relative rounded-xl overflow-hidden min-h-[160px]">
              <img src={p.image_url} alt={p.title} className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute top-3 left-3 h-10 w-10 rounded-lg bg-black/50 backdrop-blur border border-white/10 flex items-center justify-center">
                <Icon name={p.icon} className="w-4 h-4 text-white" />
              </div>
            </div>
            <div className="md:col-span-9">
              <div className="flex items-center gap-3 text-xs uppercase tracking-widest text-zinc-500">
                <span>#{String(idx + 1).padStart(2, "0")}</span>
                <span>•</span>
                <span>Sigorta Ürünü</span>
              </div>
              <h3 className="font-heading text-2xl md:text-3xl font-semibold mt-2">{p.title}</h3>
              <p className="text-zinc-300 mt-3 leading-relaxed">{p.description}</p>
              <button
                onClick={() => openForm(p.key)}
                className="mt-5 inline-flex items-center gap-2 asg-btn-primary rounded-full h-11 px-6 text-sm font-semibold"
                data-testid={`service-cta-${p.key}`}
              >
                Teklif Al <ArrowUpRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
